import { createSelector } from "reselect";
const getMyAccount = (state) => state.myAccount;
const getUnlinkOrderCall = createSelector(
  getMyAccount,
  (myAccount) => myAccount.unlinkOrderCall
);
export {
  getMyAccount,
  getUnlinkOrderCall
};
//# sourceMappingURL=selectors.js.map
